import { useState } from 'react';

import { usePolling } from '@/shared/hooks/use-polling';
import { getQueryStatus } from '../api';
import type { QueryStatus } from '../query-types';

export function useQueryProgress(workspaceId: string, queryId: string, enabled: boolean) {
  const [progress, setProgress] = useState<QueryStatus[]>([]);

  usePolling<QueryStatus[]>({
    enabled,
    queryKey: `query-status-${workspaceId}-${queryId}`,
    fetcher: () => getQueryStatus(workspaceId, queryId),
    getCompleteCondition: (data) => !data.some((item) => item.status === 'running'),
    interval: 20000,
    onComplete: (data) => {
      setProgress(data);
    },
    onFetched: (data) => {
      setProgress(data);
    },
  });

  return progress;
}
